import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-expandable-block-footer',
  templateUrl: './expandable-block-footer.component.html',
  styleUrls: ['./expandable-block-footer.component.scss']
})
export class ExpandableBlockFooterComponent {
  @Input("title") title = "Mehr anzeigen";
}
